import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorSelectPopup from "./PapersGeneratorSelectPopup";
import PropTypes from "prop-types";

const PapersGeneratorRfxInvitedSupplierWithOfferPopup = (
    {
        demandId,
        paper,
        onClose,
        shareSystem
    }) => {

    const [invitedSuppliers, setInvitedSuppliers] = useState(null);


    useEffect(() => {
        PapersGeneratorService.getRfxInvitedSupplierWithOffer(demandId).then(resp => setInvitedSuppliers(resp));
    }, [demandId])

    return (
        <PapersGeneratorSelectPopup shareSystem={shareSystem} onClose={onClose} paperId={paper.paperId} title={Tr('choose_supplier')} list={invitedSuppliers}/>
    )
}
PapersGeneratorRfxInvitedSupplierWithOfferPopup.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}
export default PapersGeneratorRfxInvitedSupplierWithOfferPopup;